export const ABOUT_LP_URL = 'https://lp.wabunka-lux.jp/about';
